import React, { forwardRef, useRef, memo } from "react";

import { OrcaPropTypes } from "./OrcaPropTypes";
import { VodPlayer } from "./components/VodPlayer";
import { OrcaContextProvider } from "./contexts/OrcaContextProvider";
import { VodDataProvider } from "./contexts/VideoDataContext/VodDataProvider";
import { FullFeatureStack } from "./contexts/featureStacks/FullFeatureStack";
import { OrcaOrYoutube } from "./components/OrcaOrYoutube";

const OrcaVOD = forwardRef(
  (
    {
      uuid,
      video,
      videoStartId,
      onVideoEnded = () => {},
      onVideoRendered = () => {},
      config = {},
      promoEnabled = true,
      isSandbox = false,
      stickyPlayerContext = {},
      orcaDeps
    },
    ref
  ) => {
    const defaultRef = useRef();
    const orcaRef = ref ?? defaultRef;

    return (
      <OrcaContextProvider
        DataProviderComponent={VodDataProvider}
        OptionalFeatureStack={FullFeatureStack}
        uuid={uuid}
        video={video}
        videoStartId={videoStartId}
        isSandbox={isSandbox}
        config={config}
        orcaRef={orcaRef}
        stickyPlayerContext={stickyPlayerContext}
        orcaDeps={orcaDeps}
      >
        <OrcaOrYoutube
          config={config}
          isSandbox={isSandbox}
          onVideoEnded={onVideoEnded}
          promoEnabled={promoEnabled}
          onVideoRendered={onVideoRendered}
          Player={VodPlayer}
        />
      </OrcaContextProvider>
    );
  }
);

OrcaVOD.displayName = "OrcaVOD";

OrcaVOD.propTypes = OrcaPropTypes;

const MemoOrca = memo(OrcaVOD);

export { MemoOrca as OrcaVOD };
